import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getJob = async (queryParams) => {
    try {
  return await get<ApiResponse<[]>>(`/individual/job?${queryParams}`).then((res)=> {
        if(res?.success===true) {
            return res
        }
        else {
            return null
        }
  })
}
catch(e){
    HandleApiError(e)
}
};
